import {
  Flex,
  IRenderControl,
  Label,
  RenderControl,
  styled,
  InfoIcon
} from '@fareye/ui'
import { useTranslation } from '@fareye/common'
import { KPI_COLORS } from '@fareye/configs'
import React from 'react'
interface IScoreCard {
  label?: string
  value?: string
  containerStyle?: React.CSSProperties
  labelStyle?: React.CSSProperties
  valueStyle?: React.CSSProperties
}
const ScoreCardContainer = styled(Flex)`
  padding: 8px;
  background: #fff;
  border-radius: 2px;
  width: 170px;
  height: 64px;
  left: 744px;
  top: 0px;
`
const ScoreCardLabel = styled.label`
  color: #727272;
  width: 90%;
  stylename: Regular/14px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
`
const ScoreCardValue = styled.label`
  stylename: Bold/18px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
`
const initialState: IRenderControl = {
  data: null,
  message: '',
  isError: false,
  isLoading: false,
  isSuccess: false
}
export default function ScoreCard({
  label,
  value,
  containerStyle,
  labelStyle,
  valueStyle,
  dataConfig,
  graphConfig,

  globalFilter
}: any) {
  const { getDataForChart } = dataConfig
  const [state, setState] = React.useState(initialState)
  React.useEffect(() => {
    fetchData()
  }, [globalFilter])
  const { t } = useTranslation()

  function generateDataForScoreCard(apiData = []) {
    let value = apiData.reduce((a: any, b: any) => {
      a += b.value
      return a
    }, 0)
    return { label: graphConfig.chartTitle, value }
  }

  async function fetchData() {
    try {
      setState({ ...state, isLoading: true })
      const apiData = await getDataForChart(graphConfig, globalFilter)
      setState({
        ...state,
        data: generateDataForScoreCard(apiData),
        isLoading: false,
        isSuccess: true,
        isError: false
      })
    } catch (ex:any) {
      setState({
        ...state,
        isLoading: false,
        message: 'No data...',
        isError: true,
        isSuccess: false
      })
    }
  }
  return (
    <ScoreCardContainer column alignItemsFlexStart justifyContentSpaceBetween>
      <RenderControl state={state}>
        <div style={{ width: '100%' }}>
          <ScoreCardLabel>{t(state.data?.label)}</ScoreCardLabel>
          <InfoIcon
            style={{ float: 'right' }}
            title={`Includes all trips with state in transit, At Destination Hub and Out for Delivery`}
          />
        </div>
        <div
          style={{
            color: (KPI_COLORS as any)[state?.data?.label] ?? ''
          }}
        >
          <ScoreCardValue>{state.data?.value}</ScoreCardValue>
        </div>
      </RenderControl>
    </ScoreCardContainer>
  )
}
